import Vue from 'vue';

Vue.filter('parseModelYear', function(years) {
  if(!years) {
      return '';
  }
  years = years.toString();
  if(years.length) {
      if(years.indexOf('?->') > -1) {
          return '';
      } else if(years.indexOf('->') > -1) {
          return years.substring(0, 7).replace('-', '.') + ' ->';
      } else {
          years = years.split(' - ');
          var st = years[0],
              et = years[1];
          if(st.indexOf('?') == -1) {
              st = st.substring(0, 7).replace('-', '.');
          }
          et = et.substring(0, 7).replace('-', '.');

          return st + ' - ' + et;
      }
  }

  return years;
})

Vue.filter('parseHW', function(hw) {
  return hw.replace(/\.00/ig, '').replace(/-/ig, '').replace(/\?/ig, '');
})

Vue.filter('parseCC', function(v) {
  return parseFloat(v) * 1000;
})

Vue.filter('parseCriteriaList', (list) => {
  let criteriaList = [];
  list = list || [];
  list.forEach(function(it) {
      var value = '';
      switch(it.genericCriteria.valueType) {
          case 'ENUM':
              value = it.enumValue.flValue;
              break;
          case 'BIGDECIMAL':
              value = it.numberValue + ' ' + (it.unit || '');
              break;
          case 'BOOLEAN':
              value = it.booleanValue;
              break;
          case 'ZONED_DATE_TIME':
              value = Vue.filter('toYearMonth')(it.dateValue);
              break;
          case 'STRING':
              value = it.stringValue;
              break;
      }
      let existIndex = -1;
      let criName = it.genericCriteria.flName;
      criteriaList.filter((item, index) => {
          if(item.key == criName) {
              existIndex = index;
              return true;
          }
          return false;
      });
      if(existIndex > -1) {
          criteriaList[existIndex] && criteriaList[existIndex].values.push(value);
      } else {
          criteriaList.push({
              key: it.genericCriteria.flName,
              values: [value]
          });
      }
  });

  return criteriaList;
})

Vue.filter('getCriteriaValues', (list, key) => {
  let items = list.filter((it) => {
      return it.key == key;
  });

  return items.length ? items[0].values : [];
})

Vue.filter('date', function(value, fmt) {
  if(!value) {
      return '';
  }

  fmt = fmt || 'yyyy-MM-dd hh:mm:ss';

  var date = value;
  if(typeof value === 'number') {
      date = new Date(value);
  } else if(typeof value === 'string') {
      if(value.indexOf('-') != -1) {
          // 对应格式2010-10-10
          return value;
      }
      value = parseInt(value, 10);
      date = new Date(value);
  } else if(Object.prototype.toString.call(value) === '[object Array]') {
      if(value.length === 3) {
          var _year = value[0],
              _month = value[1],
              _date = value[2];
          if(parseInt(_month, 10) < 10) {
              _month = '0' + _month;
          }
          if(parseInt(_date, 10) < 10) {
              _date = '0' + _date;
          }
          return [_year, _month, _date].join('-');
      }

      return value;
  }

  // 无效日期判断
  if(isNaN(date.getTime())) {
      return '';
  }

  var o = {
      "M+": date.getMonth() + 1, //月份   
      "d+": date.getDate(), //日   
      "h+": date.getHours(), //小时   
      "m+": date.getMinutes(), //分   
      "s+": date.getSeconds(), //秒   
      "q+": Math.floor((date.getMonth() + 3) / 3), //季度   
      "S": date.getMilliseconds() //毫秒   
  };
  if (/(y+)/.test(fmt))
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt))
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
})

// 转换成Date对象
Vue.filter('toDate', function(value) {
  if(typeof value === 'number') {
    return new Date(value);
  } else if(typeof value === 'string') {
    if(value.indexOf('-') > -1) {
      value = value.split('-');
      if(value.length === 3) {
        var _y = value[0],
            _m = value[1],
            _d = value[2];
        
        return new Date(_y, _m, _d);
      }
    }
  } else if(Object.prototype.toString.call(value) === '[object Array]') {
    if(value.length === 3) {
      var _year = value[0],
          _month = value[1],
          _date = value[2];
      
      return new Date(_year, _month, _date);
    }
  }

  return value;
})

Vue.filter('toShortDate', function(value) {
    return Vue.filter('date')(value, 'yyyy-MM-dd');
})

Vue.filter('toShortDateTime', function(value) {
    return Vue.filter('date')(value, 'yyyy-MM-dd hh:mm');
})

Vue.filter('toMoney', function (arg) {
    if (!arg) return '0.00';
    var str = String(Number(arg).toFixed(2));
    var newStr = "";
    var count = 0;
    if (str.indexOf(".") == -1) { // 当数字是整数
        for (var i = str.length - 1; i >= 0; i--) {
            if (count % 3 == 0 && count != 0) {
                newStr = str.charAt(i) + "," + newStr;
            } else {
                newStr = str.charAt(i) + newStr;
            }
            count++;
        }
        str = newStr + ".00"; //自动补小数点后两位
        return str;
    } else { // 当数字带有小数
        for (var i = str.indexOf(".") - 1; i >= 0; i--) {
            if (count % 3 == 0 && count != 0) {
                newStr = str.charAt(i) + "," + newStr;
            } else {
                newStr = str.charAt(i) + newStr; //逐个字符相接起来
            }
            count++;
        }
        str = newStr + (str + "00").substr((str + "00").indexOf("."), 3);
        return str;
    }
})

Vue.filter('toCount',function (num) {
    return Vue.filter('toMoney')(num).replace('.00','')
})